document.addEventListener('DOMContentLoaded', function () {

  /* ---- Menú móvil ---- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* ---- Countdown de rebajas ---- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var endDate = new Date(el.getAttribute('data-countdown')).getTime();
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = new Date().getTime();
      var distance = endDate - now;

      if (isNaN(endDate) || distance <= 0) {
        daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  });

  /* ---- Añadir al carrito (fetch API, opcional para AJAX cart) ---- */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      // El envío estándar funciona sin JS; aquí se puede interceptar
      // para mostrar un mini-carrito con fetch('/cart/add.js', {...}).
    });
  });

  /* ---- Toggle de método de pago: checkout normal vs Yape ---- */
  var paymentToggles = document.querySelectorAll('[data-payment-toggle]');
  var yapeBox = document.querySelector('[data-yape-box]');
  var yapeHint = document.querySelector('[data-yape-hint]');
  var checkoutButton = document.querySelector('[data-checkout-button]');

  function updatePaymentUI() {
    var selected = document.querySelector('[data-payment-toggle]:checked');
    if (!selected) return;
    var isYape = selected.value === 'yape';

    if (yapeBox) yapeBox.hidden = !isYape;
    if (yapeHint) yapeHint.hidden = !isYape;
    if (checkoutButton) {
      checkoutButton.textContent = isYape ? 'Confirmar pedido (pago por Yape)' : 'Finalizar compra';
    }
  }

  paymentToggles.forEach(function (radio) {
    radio.addEventListener('change', updatePaymentUI);
  });
  updatePaymentUI();

});
